import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AdminHeader, Card, StatusBadge, Empty } from "@/components/admin/ui";
import { formatINR } from "@/lib/format";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function AdminCustomerDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/admin/customers/${id}`).then(({ data }) => setData(data)); }, [id]);
  if (!data) return <div className="py-20 grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-amber-500" /></div>;
  const c = data.customer;

  return (
    <div>
      <button onClick={() => navigate("/admin/customers")} className="inline-flex items-center gap-1.5 text-sm text-slate-500 mb-3"><ArrowLeft className="h-4 w-4" /> Back</button>
      <AdminHeader title={c.name} subtitle={c.email} />
      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="p-5 space-y-2">
          <h3 className="font-semibold text-slate-900">Profile</h3>
          <p className="text-sm text-slate-600">Phone: {c.phone || "—"}</p>
          <p className="text-sm text-slate-600">Status: <StatusBadge status={c.status} /></p>
          <p className="text-sm text-slate-600">Joined: {new Date(c.createdAt).toLocaleDateString("en-IN")}</p>
        </Card>
        <Card className="p-5 lg:col-span-2">
          <h3 className="font-semibold text-slate-900 mb-3">Order History ({data.orders.length})</h3>
          {data.orders.length === 0 ? <Empty text="No orders" /> : (
            <div className="space-y-2">
              {data.orders.map((o) => (
                <div key={o.id} className="flex items-center justify-between p-2.5 rounded-lg hover:bg-slate-50 cursor-pointer" onClick={() => navigate(`/admin/orders/${o.id}`)}>
                  <span className="font-mono text-sm">{o.orderNumber}</span>
                  <div className="flex items-center gap-3"><span className="font-mono text-sm">{formatINR(o.total)}</span><span className="text-[11px] bg-amber-50 text-amber-700 px-2 py-0.5 rounded">{o.status.replace(/_/g, " ")}</span></div>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
